export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const MOVIES_URL = 'films';